import { render, staticRenderFns } from "./VerificationList.vue?vue&type=template&id=4ea8c370&"
import script from "./VerificationList.vue?vue&type=script&lang=js&"
export * from "./VerificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports